import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IGroupRepository } from '@/coreInfrastructureModule/interfaces/IGroupRepository';
import { UpdateGroupNameAdapter } from '../adapter/updateGroupNameAdapter';

/**
 * グループ名を編集するUseCase
 */
export class updateGroupNameUseCase {
  /**
   * グループ名を編集する モック関数
   * @param repository - リポジトリ
   * @param groupId - グループID
   * @param newGroupName - 新しいグループ名
   */
  public ExecuteMock = async (
    repository: IGroupRepository,
    groupId: string,
    newGroupName: string
  ): Promise<INetworkResult<void, Error>> => {
    try {
      const request = UpdateGroupNameAdapter.adaptForRequest(newGroupName);
      const result = await repository.updateGroupName(groupId, request);

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }

      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('追加に失敗しました'),
        },
      };
    }
  };
}
